import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'animate.css';
import './DashboardDJ.css'; 

const DashboardDJ = () => {
  const navigate = useNavigate();
  const [cargando, setCargando] = useState(true);
  const [userName, setUserName] = useState('');
  const [diasSeleccionados, setDiasSeleccionados] = useState([21]);

  // VERIFICACIÓN DE SEGURIDAD AL CARGAR
  useEffect(() => {
    const role = localStorage.getItem('role');
    const user = localStorage.getItem('username');

    // Bloqueo estricto: Si no es DJ, al login.
    if (role !== 'dj') {
      navigate('/login', { replace: true });
    } else {
      setUserName(user || 'DJ');
      setCargando(false);
    }

    // Prevenir que el usuario regrese a la página anterior con el botón del navegador
    // después de haber entrado al Dashboard (mantiene la sesión limpia)
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
        window.history.go(1);
    };
  }, [navigate]);

  // CIERRE DE SESIÓN LIMPIO: Borra todo y redirige
  const handleLogout = () => {
    localStorage.clear(); // Borra role, username y tokens
    navigate('/login', { replace: true });
  };

  const chats = [
    { id: 1, usuario: 'Leo8ft', mensaje: 'Hola, ¿disponibilidad para el sábado?', hora: '10:30' },
    { id: 2, usuario: 'Cesar762', mensaje: 'Oye, el evento se movió una hora.', hora: '09:15' }
  ];

  if (cargando) return null;

  return (
    <div className="dj-container">
      {/* SIDEBAR DJ */}
      <aside className="dj-sidebar">
        <div className="dj-logo-section">
          <img src="/Logo-BamboAct.png" alt="Bambo Logo" className="dj-logo" />
        </div>
        <nav className="dj-nav">
          <button className="dj-nav-item active">
            <i className="bi bi-calendar3"></i> Mi Agenda
          </button>
          <button className="dj-nav-item">
            <i className="bi bi-chat-dots"></i> Mensajes
          </button>
          <button className="dj-nav-item">
            <i className="bi bi-person-circle"></i> Perfil
          </button>
        </nav>
        <div className="dj-sidebar-footer">
          <button onClick={handleLogout} className="dj-btn-logout">
            <i className="bi bi-box-arrow-left"></i> Cerrar Sesión
          </button>
        </div>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <main className="dj-main">
        <header className="dj-topbar">
          <h4 className="dj-welcome-text">¡Hola {userName}! Ajusta tu calendario según tu disponibilidad</h4>
          <div className="dj-user-pill">
            <div className="dj-user-meta">
              <span className="dj-name">{userName}</span>
              <span className="dj-rank">Staff DJ</span>
            </div>
            <div className="dj-avatar">{userName.charAt(0).toUpperCase()}</div>
          </div>
        </header>

        <section className="dj-content animate__animated animate__fadeIn">
          <div className="dj-grid">
            
            {/* CALENDARIO */}
            <div className="dj-card calendar-box">
              <div className="dj-card-header">
                <h5 className="text-gold"><i className="bi bi-calendar-event me-2"></i>ABRIL 2026</h5>
                <select className="dj-select">
                  <option>Ver: Disponibles</option>
                  <option>Ver: Ocupados</option>
                </select>
              </div>

              <div className="dj-calendar-grid">
                {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(d => (
                  <div key={d} className="calendar-label">{d}</div>
                ))}
                {[...Array(30)].map((_, i) => {
                    const dia = i + 1;
                    return (
                      <div 
                        key={i} 
                        className={`calendar-cell ${diasSeleccionados.includes(dia) ? 'selected' : ''}`}
                        onClick={() => {
                            setDiasSeleccionados(prev => 
                                prev.includes(dia) ? prev.filter(d => d !== dia) : [...prev, dia]
                            );
                        }}
                      >
                        {dia}
                      </div>
                    );
                })}
              </div>

              <div className="dj-actions">
                {/* Se eliminó el botón de "Volver al Inicio" para mayor seguridad */}
                <button className="btn-save" style={{ width: '100%' }}>Guardar Disponibilidad</button>
              </div>
            </div>

            {/* LATERAL DERECHO */}
            <div className="dj-sidebar-info">
              <div className="dj-card status-card">
                <img src="https://i.imgur.com/8nNfRIm.png" alt="DJ Art" className="dj-art" />
                <p>Recuerda marcar tus días libres con al menos <strong>48 horas</strong> de anticipación.</p>
              </div>

              <div className="dj-card chat-card">
                <h6 className="text-gold mb-3">Chats Recientes</h6>
                <div className="dj-chat-list">
                  {chats.map(chat => (
                    <div key={chat.id} className="dj-chat-item">
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-bold">{chat.usuario}</span>
                        <small className="text-muted">{chat.hora}</small>
                      </div>
                      <p className="chat-msg">{chat.mensaje}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
};

export default DashboardDJ;